import { render, staticRenderFns } from "./staffMultiGrade.vue?vue&type=template&id=212f68a8&scoped=true&"
import script from "./staffMultiGrade.vue?vue&type=script&lang=js&"
export * from "./staffMultiGrade.vue?vue&type=script&lang=js&"
import style0 from "./staffMultiGrade.vue?vue&type=style&index=0&id=212f68a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212f68a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
